import { render, staticRenderFns } from "./ResourceTable.vue?vue&type=template&id=66bca43e&scoped=true&"
import script from "./ResourceTable.vue?vue&type=script&lang=js&"
export * from "./ResourceTable.vue?vue&type=script&lang=js&"
import style0 from "./ResourceTable.vue?vue&type=style&index=0&id=66bca43e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bca43e",
  null
  
)

component.options.__file = "ResourceTable.vue"
export default component.exports